export const ROLE_CONFIG = {
    normal: { label: 'ordinary', color: '#e2e8f0', cooldownMs: 1_000 },
    member: { label: 'member', color: '#33cc66', cooldownMs: 500 },
    vip: { label: 'VIP', color: '#fbbf24', cooldownMs: 0 },
    admin: { label: 'administrator', color: '#ff3366', cooldownMs: 0 },
};
export const DEFAULT_ROLE = 'normal';
//# sourceMappingURL=role.js.map